import Vue from 'vue'
import Vuex from 'vuex'
Vue.use(Vuex)
import facts from "../public/facts.json";

export default new Vuex.Store({
  state: {
    facts:facts['facts'],
    baseURL: facts['baseURL'],
    year: 1920,
    resetScroll:false,
    needsRender: false,
    playing: false,
    nightMode:true,
    ferriesVisible:false,
    labelsVisible: false,
    detailedView: false,
    alpha: 0,
    loadingProgress: 0,
    isNavbarVisible: true,
    visibleFactYear:0,
    isMobile: false,
    fps: 15,
    timelineAppeared: false,
    infoVisible: false
  },
  getters: {
    infoVisible: state => {
      return state.infoVisible;
    },
    timelineAppeared: state => {
      return state.timelineAppeared;
    },
    fps: state => {
      return state.fps;
    },
    isMobile: state => {
      return state.isMobile;
    },
    baseURL: state => {
      return state.baseURL;
    },
    visibleFactYear: state => {
      return state.visibleFactYear;
    },
    isNavbarVisible: state => {
      return state.isNavbarVisible;
    },
    alpha: state => {
      return state.alpha;
    },
    loadingProgress: state => {
      return state.loadingProgress;
    },
    detailedView: state => {
      return state.detailedView;
    },
    playing: state => {
      return state.playing;
    },
    nightMode: state => {
      return state.nightMode;
    },
    ferriesVisible: state => {
      return state.ferriesVisible;
    },
    labelsVisible: state => {
      return state.labelsVisible;
    },
    needsRender: state => {
      return state.needsRender;
    },
    year: state => {
      return state.year
    },
    resetScroll: state => {
      return state.resetScroll;
    },
    facts: state => {
      return state.facts
    },
    factIndex: state => {
      for(var i=1; i<state.facts.length; i++){
        if(state.year >=  state.facts[i].year && state.year<=state.facts[i].alpha_year){
              return i;
        }
      }
      return 0;
    }

  },
  mutations: {
    setInfoVisible: (state, a)  => {
      state.infoVisible = a;
    },
    setTimelineAppeared: (state, a)  => {
      state.timelineAppeared = a;
    },
    setMobile: (state, a)  => {
      state.isMobile = a;
    },
    setVisibleFactYear: (state, a)  => {
      state.visibleFactYear = a;
    },
    setLoadingProgress: (state, a)  => {
      state.loadingProgress = a;
    },
    setNavbarVisible: (state, a)  => {
      state.isNavbarVisible = a;
    },
    setAlpha: (state, a)  => {
      state.alpha = a;
    },
    setDetailedView: (state, b)  => {
      state.detailedView = b;
    },
    setPlaying: (state, b)  => {
      state.playing = b;
    },
    setNightMode: (state, b)  => {
      state.nightMode = b;
    },
    setFerriesVisible: (state, b)  => {
      state.ferriesVisible = b;
    },
    setLabelsVisible: (state, b)  => {
      state.labelsVisible = b;
    },


    setNeedsRender: (state, b)  => {
      state.needsRender = b;
    },
    setYear:(state, y)=>{
      state.year = y;
    },
    setFacts:(state, y)=>{
      state.facts = y;
    },
    setResetScroll:(state, rs)=>{
      state.resetScroll = rs;
    },
  },
  actions: {

  }
})
